import { Component, Inject, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { OrdinalDateAdapter, OrdinalDateParse, ORD_DATE_FORMATS } from '../../../adapters/ordinal-date-adapter';
import { CrackStatusesVM, CrackStausUpdateVM } from '../../../entities/component/model';
import { GETInventoryService } from '../../../services/inventory.service';
import { SetupImplementService } from '../../../setup-implement/setup-implement.service';
import { UpdateSMUReadingModel } from '../../equipment-details.model';
import { EquipmentDetailsService } from '../../equipment-details.service';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-change-crack-status',
  templateUrl: './change-crack-status.component.html',
  styleUrls: ['./change-crack-status.component.scss'],
  providers: [
    {
        provide: DateAdapter, useClass: OrdinalDateAdapter
    },
    {
        provide: MAT_DATE_FORMATS, useValue: ORD_DATE_FORMATS
    }
]
})
export class ChangeCrackStatusComponent implements OnInit {
  obsId:number;
  compName:string;
  ObsName:string;
  crackstatus:number;
  IsCrackFixed:boolean;
  currentSmu:number;
  showSMU:boolean=false;
  eventDate: Date = new Date();
  crackUpdate: CrackStausUpdateVM;
  ord: OrdinalDateParse = new OrdinalDateParse();
  savingChanges: boolean = false;
  cost:number;
      // Toggle
      minDateForAction: Date = new Date();
      maxDateForAction: Date = new Date();
      comment: string="";
      CrackStatuses: CrackStatusesVM[] = [];
  constructor(private dialogRef: MatDialogRef<ChangeCrackStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,public _inventoryService: GETInventoryService,private _notify: NotificationsService,
    private _equipment: EquipmentDetailsService,
    public _implementService: SetupImplementService) {
    }
    minDate: Date = new Date();
    equipmentId:number;
  ngOnInit() {
    this.crackUpdate = new CrackStausUpdateVM();
    if (this.data != null) {
      this.getCrackStatuses();
      console.log("data", this.data)
      this.obsId= this.data.obsId;
      this.compName= this.data.compName;
      this.ObsName= this.data.ObsName;
      this.IsCrackFixed = this.data.IsCrackFixed;
      //this.crackstatus = this.IsCrackFixed==true?1:2;
      this.crackstatus = this.getCrackStatusId(this.obsId);
      this.currentSmu = this.data.curretSmu;
      this.showSMU = this.data.curretSmu==-1?false:true;
      this.comment=this.data.Crackcomment;
      this.equipmentId = this.data.equipmentId;
      this._inventoryService.returnMinDateForImplementEvent(this.data.implementId)
      .subscribe(response => {
          if (response != "") {
              try {
                  this.minDate = new Date(response);
              }
              catch (ex) {
                  this.minDate = new Date();
              }
          }
      });
      
    }
  }

  onCloseClick(): void {
    this.dialogRef.close(false);
}

saveChanges(){
  this.savingChanges =true;
  this.crackUpdate.smu= this.currentSmu;
  this.crackUpdate.obsId=this.obsId;
  this.crackUpdate.status = this.crackstatus == 1?true:false;
  this.crackUpdate.statusId = this.crackstatus;
  this.crackUpdate.date =this.eventDate;
  this.crackUpdate.comment=(this.comment==null || this.comment==undefined)?"":this.comment;
  this.crackUpdate.cost=this.cost==null?0:this.cost;

  let updateModel = new UpdateSMUReadingModel();
  updateModel.currentReading = this.currentSmu;
  updateModel.dateReadSMU = this.eventDate;
  updateModel.equipmentId = this.equipmentId;
  updateModel.startDate = this.eventDate;
  updateModel.endDate = this.eventDate;
  updateModel.bcm = 0;
  updateModel.ton = 0;

  if(this.equipmentId>0){
    this._equipment.changeSMUReading(updateModel).subscribe(succeeded => {
    
      if (succeeded.m_Item1) {
        this._inventoryService.CrackStatusUpdate(this.crackUpdate).subscribe(res=>{
          if(res==true){
            this._notify.success('Saved', "Sucessfully updated crack status");
            this.dialogRef.close(true);
            
          }else{
            this._notify.success('Error', "Failed update crack status");
          }
      })
  
      }});
  }else{
    this._inventoryService.CrackStatusUpdate(this.crackUpdate).subscribe(res=>{
      if(res==true){
        this._notify.success('Saved', "Sucessfully updated crack status");
        this.dialogRef.close(true);
        
      }else{
        this._notify.success('Error', "Failed update crack status");
      }
  })
  }
}


// Date
dateChanged(): void {
  this.crackUpdate.date = this.eventDate;
  
  this.ord.formatDateOrdinal((this.eventDate.toString())
      .split(' ')
      .slice(1)
      .join(' '), false);
}

// Comment
commentChanged(): void {
  this.crackUpdate.comment = this.comment;
}

ChangeObsStatus(st){
  this.crackUpdate.status = st==1?true:false;
}


getCrackStatuses()
  {
    this._inventoryService.getCrackStatuses()
      .subscribe(res => {
        if(res){
          this.CrackStatuses = res;
        }
      });
    }
    getCrackStatusId(GETObservationPointId: number) : any
    {
      this._inventoryService.getCrackStatusId(GETObservationPointId)
        .subscribe(res => {
          if(res != null){
            this.crackstatus = res;
          }
          else
            this.crackstatus = 2;
        });
      }

}
